import React, { useState, useEffect } from 'react';
import { Flame, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-red-900/20' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="relative">
              <Flame className="w-10 h-10 text-red-600 animate-pulse" />
              <div className="absolute inset-0 blur-xl bg-red-600/50"></div>
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-black text-white tracking-wider">
                RASPUTIN
              </h1>
              <p className="text-xs text-yellow-500 font-semibold tracking-widest">MOLHO PICANTE</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-red-500 font-bold tracking-wide transition-colors duration-300"
            >
              SOBRE
            </button>
            <button
              onClick={() => scrollToSection('intensity')}
              className="text-white hover:text-red-500 font-bold tracking-wide transition-colors duration-300"
            >
              INTENSIDADE
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-white hover:text-red-500 font-bold tracking-wide transition-colors duration-300"
            >
              GALERIA
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-red-600 hover:bg-red-700 text-white font-bold px-6 py-2 shadow-lg shadow-red-600/50 transition-all duration-300 hover:shadow-red-600/80 hover:scale-105"
            >
              CONTATO
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-red-900/30 bg-black/95">
            <div className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('about')}
                className="text-white hover:text-red-500 font-bold tracking-wide transition-colors duration-300 text-left"
              >
                SOBRE
              </button>
              <button
                onClick={() => scrollToSection('intensity')}
                className="text-white hover:text-red-500 font-bold tracking-wide transition-colors duration-300 text-left"
              >
                INTENSIDADE
              </button>
              <button
                onClick={() => scrollToSection('gallery')}
                className="text-white hover:text-red-500 font-bold tracking-wide transition-colors duration-300 text-left"
              >
                GALERIA
              </button>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-red-600 hover:bg-red-700 text-white font-bold w-full"
              >
                CONTATO
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
